import React, { useMemo } from "react";
import { useTicket } from "../../../store/Store";
import { processAdjustmentsData } from "../../general/AppHelpers";
import AdjustmentItem from "../AdjustmentItem";
import { useTranslation } from "react-i18next";
import { ClassesIcon } from "../../general/Icons";

const Classes = () => {
  const { data: ticketData } = useTicket();
  const { t } = useTranslation();

  const { sessionEnrollmentAdjustments } = useMemo(
    () => processAdjustmentsData(ticketData?.resource?.adjustments),
    [ticketData]
  );

  const classAdjustmentElements = useMemo(() => {
    return sessionEnrollmentAdjustments?.map(
      ({ adjustment, associatedTaxes }, index) => (
        <AdjustmentItem
          key={`class-${index}`}
          adjustment={adjustment}
          taxes={associatedTaxes}
        />
      )
    );
  }, [sessionEnrollmentAdjustments]);

  if (!classAdjustmentElements?.length) return null;

  return (
    <div className="py-5" data-testid="classes-container">
      <div
        className="flex items-center gap-2 mb-2"
        data-testid="classes-header"
      >
        <ClassesIcon />
        <h3
          className="text-lg font-medium text-black"
          data-testid="classes-title"
        >
          {t("ticketItemsSections.classes")}
        </h3>
      </div>
      <div className="flex flex-col gap-2" data-testid="classes-list">
        {classAdjustmentElements}
      </div>
    </div>
  );
};

export default Classes;
